import * as React from "react";

import "./about.css";
import Page from "../shared/Page";
import AboutBlurb from "./AboutBlurb";


const About: React.FC = (props) => {

    return (
        <Page header={"About"}>

            <AboutBlurb />

            <h2 className="text-xl">Contact</h2>
            <p>
                You can reach me at info@vaclist.net
                <br></br>
                <a href="/privacy">The privacy policy can be found here.</a>
            </p>

            <h2 className="text-xl">Reference</h2>
            <ul className="list-disc" style={{ wordWrap: "break-word" }}>
                <li><a href="https://steamcommunity.com/dev">https://steamcommunity.com/dev</a></li>
                <li><a href="https://developer.valvesoftware.com/wiki/Steam_Web_API#GetPlayerSummaries_.28v0002.29">https://developer.valvesoftware.com/wiki/Steam_Web_API#GetPlayerSummaries_.28v0002.29</a></li>
                <li><a href="https://developer.valvesoftware.com/wiki/Steam_Web_API#GetPlayerBans_.28v1.29">https://developer.valvesoftware.com/wiki/Steam_Web_API#GetPlayerBans_.28v1.29</a></li>
            </ul>
        </Page>
    );
}

export default About;